import { useContext } from 'react';
import { LoginButton } from './loginButton';
import { LogoutButton } from './logoutButton';
import { AppUserContext } from '../../context/appUserContext';


export function AuthenticationButton() {

    const { appUser } = useContext(AppUserContext);

    return (<div>
        {appUser ? <LogoutButton user={appUser} /> : <LoginButton />}
    </div>);
};